import { render, staticRenderFns } from "./Int.vue?vue&type=template&id=41648f90&"
import script from "./Int.vue?vue&type=script&lang=js&"
export * from "./Int.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QSelect,QInput} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QSelect,QInput})
